import React, { useState } from 'react'
import '../../styles/pages/padel/style.css';
const PadelRegistration = () => {
    const [showIframe, setShowIframe] = useState(false);
    const handleClick = () => {
      setShowIframe(true);
    };
  return (
        <div className="padel-container">
                <div className='coverOverlay'>
                    <div className='img-container'>
                        <div className='svg-img'>
                            <img src="./media/images/PadelcourtsLandingPage2.jpg" alt=
                            "Padel Courts" className='img'/>
                        </div>
                       
                    </div>
                     {
                            !showIframe?
                                <div className='green-button'>
                                    <button className="big-green-button" onClick={handleClick}>
                                        REGISTER NOW!
                                    </button>
                                </div>
                                :
                                <div className='iframe-content'>
                                    <iframe
                                        title="External Content"
                                        src="https://lifesportsclub.zohobookings.com/portal-embed#/courttest"
                                        className="saving"
                                        frameBorder="0"
                                    />
                                </div>
                        }
                </div>
            </div>
  )
}

export default PadelRegistration
